import { useTheme } from '@mui/material';

export const BenefitImproveIcon = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
    } = theme.colors.other.icon;

    return (
        <svg
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                stroke={primaryStroke}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.5}
                d="M7 24.88V21h9.333v28H7v-3.5m9.333 1.167A22.096 22.096 0 0 0 26.227 49h9.8a9.333 9.333 0 0 0 9.053-7l3.78-15.12A4.667 4.667 0 0 0 44.333 21h-7a72.62 72.62 0 0 0 .28-8.797A5.32 5.32 0 0 0 32.247 7h-.117a5.134 5.134 0 0 0-5.017 4.013c-.84 3.5-1.726 6.604-2.59 9.147a4.667 4.667 0 0 1-4.41 3.173h-3.78v23.334Z"
            />
        </svg>
    );
};
